import { ClockIcon, LayoutDashboardIcon, UsersIcon } from "lucide-react";
import { GrServices } from "react-icons/gr";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "./sidebar.css";

const Sidebar = () => {
  const { isOpen } = useSelector((state) => state.sidebar);
  const { flag } = useSelector((state) => state.chat);
  const { pathname } = useLocation();

  return (
    <>
      <div
        className={`partner-sidebar h-[calc(100vh-96px)] glass-header overflow-y-auto z-20 sticky top-[96px]`}
      >
        <ul className="partner-ul">
          <Link
            className={`partner-link ${
              pathname.includes("dashboard") && "bg-[#d5e6f6]"
            }`}
            to={"/partner/dashboard"}
          >
            <LayoutDashboardIcon className="text-muted-foreground size-6" />
            Dashboard
          </Link>

          <Link
            className={`partner-link ${
              pathname.includes("/partner/requests") && "bg-[#d5e6f6]"
            }`}
            to={"/partner/requests"}
          >
            <ClockIcon className="text-muted-foreground size-6" />
            Requests
          </Link>
          <Link
            className={`partner-link ${
              pathname.includes("/partner/clients") && "bg-[#d5e6f6]"
            }`}
            to={"/partner/clients"}
          >
            <UsersIcon className="text-muted-foreground size-6" />
            Clients
          </Link>
          <Link
            className={`partner-link ${
              pathname.includes("/partner/assigned-services") && "bg-[#d5e6f6]"
            }`}
            to={"/partner/assigned-services"}
          >
            <GrServices className="text-muted-foreground size-6" />
            Assigned Services
          </Link>
          {/* <Link className="link" to={"/partner/dashboard"}>Dashboard</Link>
                    <Link className="link" to={"/partner/requests"}>Requests</Link>
                    <Link className="link" to={"/partner/clients"}>Clients</Link> */}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;
